var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 852,
    viewBox: "0 0 1920 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 852,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2398.36 -499.685C2787.52 -318.914 2954.19 147.97 2770.63 543.129C2587.07 938.288 2122.79 1112.08 1733.63 931.313C1344.48 750.542 1177.8 283.658 1361.36 -111.501C1544.92 -506.66 2009.2 -680.456 2398.36 -499.685ZM1913.95 543.137C2091.98 625.836 2304.37 546.328 2388.35 365.553C2472.32 184.777 2396.07 -28.811 2218.04 -111.509C2040.01 -194.208 1827.62 -114.7 1743.64 66.0752C1659.67 246.851 1735.92 460.439 1913.95 543.137Z",
    fill: "url(#paint0_linear_4_4)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M894.354 1337.87C748.917 1538.6 478.709 1590.97 290.827 1454.84C102.944 1318.71 68.5355 1045.63 213.972 844.903C359.409 644.175 629.618 591.809 817.5 727.939C1005.38 864.068 1039.79 1137.15 894.354 1337.87ZM398.534 978.627C332 1070.45 347.742 1195.38 433.693 1257.66C519.645 1319.93 643.259 1295.98 709.792 1204.15C776.326 1112.32 760.585 987.395 674.633 925.119C588.682 862.843 465.068 886.799 398.534 978.627Z",
    fill: "url(#paint1_linear_4_4)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.659 -379.791C511.252 -245.471 535.387 -13.2816 406.566 138.818C277.746 290.917 44.7506 305.33 -113.842 171.01C-272.435 36.689 -296.57 -195.5 -167.749 -347.6C-38.9283 -499.699 194.067 -514.112 352.659 -379.791ZM-44.4845 89.1185C66.9504 183.498 230.664 173.371 321.179 66.4991C411.695 -40.3731 394.737 -203.52 283.302 -297.9C171.867 -392.28 8.15354 -382.153 -82.3621 -275.281C-172.878 -168.409 -155.919 -5.26142 -44.4845 89.1185Z",
    fill: "#1B6023"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4_4",
    x: 1079.63,
    y: -778.29,
    width: 1972.74,
    height: 1988.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 103.55,
    result: "effect1_foregroundBlur_4_4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4_4",
    x: -83.162,
    y: 445.097,
    width: 1274.65,
    height: 1292.58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 103.55,
    result: "effect1_foregroundBlur_4_4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4_4",
    x: -444.757,
    y: -666.013,
    width: 1128.33,
    height: 1123.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 97.1,
    result: "effect1_foregroundBlur_4_4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_4",
    x1: 1594.02,
    y1: -612.35,
    x2: 2558.21,
    y2: 1286.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32C3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E934F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_4",
    x1: 1065.7,
    y1: 958.247,
    x2: -91.6287,
    y2: 1238.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32C3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E934F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 852,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login_bg.40329606c04a0e1d83d611b440d49b6a.svg";
export { ForwardRef as ReactComponent };